<template>
    <div class="page profile-wraper page-current">

        <Top></Top>
        
        <div class="navbar hidden-lg hidden-xl navbar-style-2">
            <div class="navbar-inner">
                <div class="left">
                    <a class="link back" style="">
                        <i class="las la-bars" v-on:click="menu" style="font-size: 30px; color: var(--f7-theme-color-white)"></i>
                    </a>
                </div>
                <div class="title" style="">Minha conta</div>
                <div class="right">
                    <a class="link back" style="opacity: 0">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        
        <!-- Page Content -->
        <div class="page-content content-area bottom-sp70 pt-70" v-bind:class="{'disabled': $root.user.confirmacao == 0}">


            <div class="hidden-xs hidden-md container" style="text-align: center; margin-top: 50px" v-if="$root.user.tipo == 'prestador' && !$root.user.empresaCod">
                <h5 v-if="$root.user.confirmacao == 1 && !$root.user.pagamentoId" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 10px;">
                    <i class="las la-exclamation-triangle"></i>
                    Você precisa cadastrar sua conta bancária para começar a trabalhar.
                </h5>

                <h5 v-if="$root.user.confirmacao == 0" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 25px;">
                    <i class="las la-exclamation-triangle"></i>
                    Seu <b style="font-weight: 600;">cadastro está em análise</b> pela nossa equipe. Você <b style="font-weight: 600;">receberá</b> uma <b style="font-weight: 600;">notificação</b> quando tudo estiver pronto para começar a <b style="font-weight: 600;">trabalhar</b>.
                </h5>
                <h5  v-if="$root.user.confirmacao == -1" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 25px;">
                    <i class="las la-exclamation-triangle"></i>
                    Infelizmente seu cadastro foi negado pela nossa equipe. Entre em contato caso tenha dúvidas.
                </h5>      

                <button v-if="$root.user.confirmacao == 1 && !$root.user.pagamentoId" v-on:click="$root.go('Carteira')" type="button" class="button button-fill button-large color-green block-mobile " style="margin-bottom: 28px">
                    <i class="las la-money-bill-wave"></i>
                    Cadastrar dados bancários
                </button>                                                                
            </div>

            <div v-if="$root.user.tipo == 'empresa' || ($root.user.tipo == 'prestador' && $root.user.empresaCod)" class="hidden-xs hidden-sm hidden-md" style="height: 50px"></div>
            <div class="hidden-xs hidden-md " v-if="$root.user.tipo == 'prestador' && !$root.user.empresaCod" v-bind:class="{'disabled': ($root.user.confirmacao != 1 || (!$root.user.pagamentoId && !$root.user.empresaCod))}">
                <div class="mb-30 pa-15 row grouped-cards">                                                                                                                                                  
                    <div v-if="!$root.user.empresaCod" class="col-auto click" v-on:click="$root.go('Agendas', JSON.stringify({'voltar': true, 't': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/schedule.png" alt="" class="categories-icon" style="width: 37px;">
                            <h6 class="title">
                                Opções de<br>atendimento  
                            </h6>
                        </div>
                    </div>                                                                                                                                                       
                    <div v-if="!$root.user.empresaCod" class="col-auto click" v-on:click="$root.go('VisualizarHorarios', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/agenda.png" alt="" class="categories-icon" style="width: 42px;">
                            <h6 class="title">
                                Visualizar<br>agenda  
                            </h6>
                        </div>
                    </div>                                                                                                                                                       
                    <div class="col-auto click" v-on:click="$root.go('Pedidos', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/times.png" alt="" class="categories-icon" style="width: 38px;">
                            <h6 class="title">
                                Meus<br>pedidos  
                            </h6>
                        </div>
                    </div>     
                    <div class="col-auto click" v-on:click="$root.go('Pacientes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/users.png" alt="" class="categories-icon" style="width: 38px;">
                            <h6 class="title">
                                Meus<br>pacientes  
                            </h6>
                        </div>
                    </div>                                                                                                                                                                           
                    <div v-if="!$root.user.empresaCod" class="col-auto click" v-on:click="$root.go('Informacoes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/infos.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Informações<br>gerenciais  
                            </h6>
                        </div>
                    </div>                                                                                                                                                                                                                                                                                     
                    <div v-if="!$root.user.empresaCod" class="col-auto click" v-on:click="$root.go('Carteira', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/bank.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Dados<br>bancários  
                            </h6>
                        </div>
                    </div>                                                                                                                                            

                    <div v-if="!$root.user.empresaCod" class="col-auto click" v-on:click="$root.go('Cupons')">
                        <div class="categories-bx">
                            <img src="static/images/icons/discount.png" alt="" class="categories-icon" style="width: 4px;">
                            <h6 class="title">
                                Cupons de<br>desconto
                            </h6>
                        </div>                                                                                                                                   
                    </div>

<!--                     <div class="col-auto click" v-on:click="$root.go('Contato')">
                        <div class="categories-bx">
                            <img src="static/images/icons/contact.png" alt="" class="categories-icon" style="width: 38px;">
                            <h6 class="title">
                                Fale<br>conosco  
                            </h6>
                        </div>                                                                                                                                   
                    </div> -->
                </div>
            </div>

            <div class="hidden-xs hidden-md " v-if="$root.user.tipo == 'admin'">
                <div class="mb-30 pa-15 row grouped-cards">
                    <div class="col-auto click" v-on:click="$root.go('Pacientes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/users.png" alt="" class="categories-icon" style="width: 42px;">
                            <h6 class="title">
                                Pacientes
                            </h6>
                        </div>
                    </div>
                    <div class="col-auto click" v-on:click="$root.go('Profissionais', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/health.png" alt="" class="categories-icon" style="width: 42px;">
                            <h6 class="title">
                                Profissionais
                            </h6>
                        </div>
                    </div>                    
                    <div class="col-auto click" v-on:click="$root.go('Pedidos', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/agenda.png" alt="" class="categories-icon" style="width: 42px;">
                            <h6 class="title">
                                Pedidos
                            </h6>
                        </div>
                    </div>
                    <div class="col-auto click" v-on:click="$root.go('Configuracoes')">
                        <div class="categories-bx">
                            <img src="static/images/icons/cog.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Configurações
                            </h6>
                        </div>
                    </div>
                    <div class="col-auto click" v-on:click="$root.go('Profissoes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/cog.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Profissões
                            </h6>
                        </div>
                    </div>
                    <div class="col-auto click" v-on:click="$root.go('Especialidades', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/cog.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Especialidades
                            </h6>
                        </div>
                    </div>
                    <div class="col-auto click" v-on:click="$root.go('Avaliacoes')">
                        <div class="categories-bx">
                            <img src="static/images/icons/ratings.png" style="width: 50px !important;" alt="" class="categories-icon">
                            <h6 class="title">
                                Avaliações
                            </h6>
                        </div>
                    </div>
                    <div class="col-auto click" v-on:click="$root.go('Cupons')">
                        <div class="categories-bx">
                            <img src="static/images/icons/discount.png" alt="" class="categories-icon" style="width: 4px;">
                            <h6 class="title">
                                Cupons de<br>desconto
                            </h6>
                        </div>
                    </div>
                    <div class="col-auto click" v-on:click="$root.go('Empresas')">
                        <div class="categories-bx">
                            <img src="static/images/icons/business-and-trade.png" alt="" class="categories-icon" style="width: 4px;">
                            <h6 class="title">
                                Empresas
                            </h6>
                        </div>
                    </div>    
                    <div class="col-auto click" v-on:click="$root.go('Usuarios')">
                        <div class="categories-bx">
                            <img src="static/images/icons/workers.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Usuários
                            </h6>
                        </div>
                    </div>                                    
                </div>
            </div>  

            <div class="profile-info bg-primary">
                <div class="container">
                    <div class="row">
                        <div class="col-100 large-40">
                            <avatar-cropper
                              @submit="submitAvatar"
                              @uploading="uploadAvatar"
                              :labels="{ 'submit': 'Ok', 'cancel': 'Cancelar'}"
                              :upload-handler="uploadAvatar"
                              trigger="#avatar-imagem" />
                            <div class="author">
                                <div style="position: relative; z-index: 9999;" id="avatar-imagem">
                                    <img :src="form.imagem" alt="" >
                                </div>
                            </div>
                            <div class="profile-content">
                                <h2 class="name">
                                    {{$root.user.nome}}
                                </h2>
                                <p>
                                    <span>
                                        {{$root.user.email}}
                                    </span>
                                </p>
                            </div>
                            <center>

                                <div class="profile-buttons mt-15">
                                    <button v-on:click="$root.go('AlterarSenha')" class="button button-medium button-outline button-fill color-white text-color-black mr-5" style="width: calc(60% - 5px);">
                                        Alterar senha
                                        <i class="las la-user-lock"></i>
                                    </button>
                                    <button v-on:click="$root.logout()" class="button button-medium button-fill button-outline border-color-white ml-5" style="width: calc(40% - 5px);">
                                        Sair
                                        <i class="las la-sign-out-alt"></i>
                                    </button>
                                    <button v-if="$root.user.tipo == 'prestador' && !$root.user.empresaCod" v-on:click="$root.go('Carteira')" class="button button-medium button-outline button-fill color-white text-color-black mt-10 mb-15" style="width: 100%;">
                                        Dados bancários
                                        <i class="las la-money-bill"></i>
                                    </button>
                                </div>
                                <div v-if="$root.user.tipo == 'prestador' && !$root.user.empresaCod" class="mt-10 mb-0" style="position: relative; width: 100%; max-width: 100%;">
                                    <div class="carteira-conta">
                                        <center>
                                            <p class="title">
                                                <i class="las la-money-bill"></i>
                                                Carteira digital
                                            </p>
                                            <h1 style="color: #fff; margin: 0px; display: block; width: 100%;">
                                                <b>R$ {{saldo.AmountAvailableToday | toMoney }}</b>
                                            </h1>
                                            <p style="margin: 0px; color: #fff;  font-size: 14px; display: block; width: 100%;">
                                                Saldo a liberar:&nbsp;&nbsp;<b>R$ {{saldo.AmountPreviewTotal | toMoney }}</b>
                                            </p>   

                                            <div style="height: 1px; width: 100%; display: block;">
                                                
                                            </div>

                                            <button v-bind:class="{'disabled': saldo.AmountAvailableToday == 0}" v-on:click="sacar()" class="button-outline button button-medium color-white mb-5">
                                                Sacar valor disponível
                                            </button>                                                                 

                                            <a v-on:click="$root.go('Saques')" style="text-decoration: underline; color: #fff; font-size: 12px; display: block; margin-top: 0px; opacity: 0.7;">
                                                Extrato de recebimentos e saques
                                            </a>
                                        </center>
                                    </div>         
                                </div>

                            </center>
                        </div>
                        <div class="col-100 large-60 hidden-xs hidden-md">

                            <div class="row pb-10">
                                
                                <form class="tab tab-active" id="tabA1" method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                                    
                                    <div class="list mt-0 no-hairlines-ios">                                           
                                        <ul class="row" style="border-radius: 15px;">              
                                            <li class="item-content">
                                                <p style="padding-left: 0px">
                                                    <i class="las la-user-circle"></i>
                                                    Dados gerais
                                                </p> 
                                            </li>
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Qual a sua profissão? <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <select id="categoriaCod" class="form-control" name="categoriaCod" required="" v-model="form.categoriaCod">
                                                            <option value="" disabled selected hidden>Selecione..</option>
                                                            <option v-for="(item, index) in profissoes.itens" v-if="item.tipo == 'profissao'" :key="item.cod + '-slide2'" :value="item.cod" >{{item.nome}}</option>
                                                           
                                                        </select>                                                  
                                                    </div>
                                                </div>
                                            </li>        
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Especialidade(s) <small>(opcional)</small></div>
                                                    <div class="item-input-wrap" v-on:click="autocompleteEspecialidades()">
                                                        <input type="text" placeholder="Toque para selecionar..." readonly="" value="" class="form-control" v-model="especialidades.nomes"/>
                                                    </div>
                                                </div>
                                            </li>                                                                                       
                                            <li class="item-content item-input col-100">
                                                <div class="item-inner">
                                                    <div class="item-title item-label" v-if="profissoes.ativa.empresa == 0">Nome <small>(obrigatório)</small></div>
                                                    <div class="item-title item-label" v-if="profissoes.ativa.empresa == 1">Nome do responsável pela empresa <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="text" v-model="form.nome" placeholder="Escreva o nome aqui" value="" class="form-control"/>
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input col-100" v-if="profissoes.ativa.empresa == 1">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Nome fantasia <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="text" v-model="form.empresa" placeholder="Nome da empresa" value="" class="form-control"/>
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input col-100" v-if="profissoes.ativa.empresa == 1">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Razão social da empresa <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="text" v-model="form.razaoSocial" placeholder="Escreva a razão social" value="" class="form-control"/>
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador' && profissoes.ativa.empresa == 0">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Registro de classe <small>(opcional)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="text" v-model="form.registroClasse" placeholder="Escreva aqui.." value="" class="form-control"/>
                                                    </div>
                                                </div>
                                            </li>                                        
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador' && profissoes.ativa.empresa == 0">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">RQE <small>(opcional)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="number" v-model="form.rqe" placeholder="Escreva seu RQE se possuir.." value="" class="form-control"/>
                                                    </div>
                                                </div>
                                            </li>  
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo != 'admin' && $root.user.tipo != 'empresa'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label" v-if="$root.user.tipo == 'contratante' || form.tipo == 'entregador'">CPF <small>(obrigatório)</small></div>
                                                    <div class="item-title item-label" v-if="$root.user.tipo == 'prestador'">CPF do responsável <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <the-mask :mask="['###.###.###-##']" readonly type="tel" class="form-control" autocomplete="new-password" v-model="form.doc" placeholder="Informe seu CPF" required />
                                                    </div>
                                                </div>
                                            </li>            
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador' && profissoes.ativa.empresa == 1">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">CNPJ <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <the-mask type="tel" :mask="['##.###.###/####-##']" class="form-control" v-model="form.cnpj" :placeholder="'Informe o CNPJ da empresa'"/>
                                                    </div>
                                                </div>
                                            </li>                                                                   
                                            <li class="item-content item-input col-100">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">E-mail <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="email" v-model="form.email" placeholder="Escreva seu melhor e-mail" value="" class="form-control"/>
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo != 'empresa'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Celular <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva seu celular" autocomplete="new-password" v-model="form.telefone" />
                                                    </div>
                                                </div>
                                            </li>                                                                            
                                            <li class="item-content item-input col-100" v-if="profissoes.ativa.empresa == 0 && $root.user.tipo != 'admin' && $root.user.tipo != 'empresa'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label" v-if="$root.user.tipo == 'contratante' || form.tipo == 'entregador'">Data de nascimento <small>(obrigatório)</small></div>
                                                    <div class="item-title item-label" v-if="$root.user.tipo == 'prestador'">Data de nascimento do responsável <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <the-mask :mask="['##/##/####']" :masked="true" type="tel" placeholder="Sua data de nascimento" value="" class="form-control" autocomplete="new-password" v-model="form.dataNascimento"  required />
                                                    </div>
                                                </div>
                                            </li>    
                                            <li class="item-content item-input col-100 pb-10" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Palavras-chave <small>(opcional)</small></div>
                                                    <div class="item-input-wrap ">
                                                        <div class="row">
                                                            <div class="col-80">
                                                                <input type="text" v-model="palavrasChave" v-on:keydown.enter.stop.prevent="addPalavrasChave" placeholder="Escreva a palavra-chave" value="" class="form-control "/>
                                                            </div>                                                                                                
                                                            <div class="col-15">
                                                                <button type="button" v-on:click="addPalavrasChave" class="button button-fill col-20">
                                                                    <i class="las la-plus" style="font-size: 24px; margin-right: 0px"></i>
                                                                </button>                                                                                                
                                                            </div>                                                                                                
                                                        </div>                                                                                                

                                                          <div class="chip" v-for="(item, index) in form.palavrasChave" v-if="item">
                                                            <div class="chip-label">{{item}}</div><a v-on:click="delPalavrasChave(item)" class="chip-delete"></a>
                                                          </div>                                           
                                                    </div>
                                                </div>
                                            </li>                                              
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Currículo <small>(opcional)</small></div>
                                                    <div class="item-input-wrap">
                                                        <textarea v-model="form.descricao" style="min-height: 250px; background: #f7f7f7; padding: 5px" placeholder="Escreva o seu currículo aqui.." class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            </li>                                                                                                                   
                                            <li class="item-content col-100" v-if="$root.user.tipo == 'prestador'">
                                                <p style="padding-left: 12px" v-if="$root.user.tipo == 'prestador'">
                                                    <i class="las la-map-marker"></i> 
                                                    Endereço
                                                </p>
                                            </li>

                                            <li class="item-content item-input col-60" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">CEP <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <the-mask :mask="['#####-###']" :masked="true" type="tel" class="form-control" v-model="form.cep" placeholder="_____-___" />
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Rua <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="text" v-model="form.endereco" placeholder="Escreva o seu endereço.." value="" class="form-control" />
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Número (obrigatório)</div>
                                                    <div class="item-input-wrap">
                                                        <input type="tel" v-model="form.numero" placeholder="__" value="" class="form-control" />
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Complemento <small>(opcional)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="text" v-model="form.complemento" placeholder="" value="" class="form-control"/>
                                                    </div>
                                                </div>
                                            </li>     
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Bairro <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="text" v-model="form.bairro" placeholder="Escreva o seu bairro.." value="" class="form-control" />
                                                    </div>
                                                </div>
                                            </li>            
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador' || $root.user.tipo == 'empresa'" >
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Cidade <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <input type="text" v-model="form.cidade" placeholder="Escreva a sua cidade.." value="" class="form-control" />
                                                    </div>
                                                </div>
                                            </li>     
                                            <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador' || $root.user.tipo == 'empresa'">
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Estado <small>(obrigatório)</small></div>
                                                    <div class="item-input-wrap">
                                                        <select id="estado" class="form-control" readonly="" name="estado" required="" v-model="form.estado" >
                                                            <option value="" disabled selected hidden>Estado</option>
                                                            <option value="AC">Acre</option>
                                                            <option value="AL">Alagoas</option>
                                                            <option value="AP">Amapá</option>
                                                            <option value="AM">Amazonas</option>
                                                            <option value="BA">Bahia</option>
                                                            <option value="CE">Ceará</option>
                                                            <option value="DF">Distrito Federal</option>
                                                            <option value="ES">Espírito Santo</option>
                                                            <option value="GO">Goiás</option>
                                                            <option value="MA">Maranhão</option>
                                                            <option value="MT">Mato Grosso</option>
                                                            <option value="MS">Mato Grosso do Sul</option>
                                                            <option value="MG">Minas Gerais</option>
                                                            <option value="PA">Pará</option>
                                                            <option value="PB">Paraíba</option>
                                                            <option value="PR">Paraná</option>
                                                            <option value="PE">Pernambuco</option>
                                                            <option value="PI">Piauí</option>
                                                            <option value="RJ">Rio de Janeiro</option>
                                                            <option value="RN">Rio Grande do Norte</option>
                                                            <option value="RS">Rio Grande do Sul</option>
                                                            <option value="RO">Rondônia</option>
                                                            <option value="RR">Roraima</option>
                                                            <option value="SC">Santa Catarina</option>
                                                            <option value="SP">São Paulo</option>
                                                            <option value="SE">Sergipe</option>
                                                            <option value="TO">Tocantins</option>
                                                        </select>                                                  
                                                    </div>
                                                </div>
                                            </li>  
                                            <li class="item-content col-100">
                                                <button type="submit" class=" button-large button button-fill color-green mb-10 mt-20" style="width: 100%; display: block;">
                                                    <i class="las la-save"></i> 
                                                    Salvar dados
                                                </button>
                                            </li>  
                                        </ul>                                  
                                    </div>
                                </form>

                            </div>
                        </div>
                
                    </div>
                   
                </div>
            </div>  


            <div class="tabs fixed-content hidden-xl hidden-lg" style="border-radius: 0px;">
                
                <div id="list_edit" class="tab tab-active">

                        <div class="container">
                            <div class="title-bar">
                                <h5 class="dz-title" style="width: 100%;">
                                    <i class="las la-user-edit"></i>
                                    Minhas informações
                                </h5>
                            </div>
                        </div>
                    <div class="row pb-10">
                        
                        <form class="tab tab-active" id="tabA1" method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                            
                            <div class="list mt-0 no-hairlines-ios">
                                <p style="padding-left: 12px">
                                    Dados gerais
                                </p>                                            
                                <ul class="row">              
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Qual a sua profissão? <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <select id="categoriaCod" class="form-control" name="categoriaCod" required="" v-model="form.categoriaCod">
                                                    <option value="" disabled selected hidden>Selecione..</option>
                                                    <option v-for="(item, index) in profissoes.itens" v-if="item.tipo == 'profissao'" :key="item.cod + '-slide'" :value="item.cod" >{{item.nome}}</option>
                                                   
                                                </select>                                                  
                                            </div>
                                        </div>
                                    </li>        
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Especialidade(s) <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap" v-on:click="autocompleteEspecialidades()">
                                                <input type="text" placeholder="" readonly="" value="" class="form-control" v-model="especialidades.nomes"/>
                                            </div>
                                        </div>
                                    </li>                                                                                       
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label" v-if="$root.user.tipo == 'contratante' || $root.user.tipo == 'admin'">Nome <small>(obrigatório)</small></div>
                                            <div class="item-title item-label" v-if="$root.user.tipo == 'prestador'">Nome do responsável <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.nome" placeholder="Seu nome" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Registro de classe <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.registroClasse" placeholder="Escreva aqui.." value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>                           
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label">E-mail <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="email" v-model="form.email" placeholder="Seu e-mail" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Celular <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva seu celular" autocomplete="new-password" v-model="form.telefone" />
                                            </div>
                                        </div>
                                    </li>                                    
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo != 'admin'">
                                        <div class="item-inner">
                                            <div class="item-title item-label" v-if="$root.user.tipo == 'contratante' || $root.user.tipo == 'admin'">CPF <small>(obrigatório)</small></div>
                                            <div class="item-title item-label" v-if="$root.user.tipo == 'prestador'">CPF do profissional <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['###.###.###-##']" type="tel" class="form-control" autocomplete="new-password" v-model="form.doc" placeholder="Informe seu CPF" required />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'contratante'">
                                        <div class="item-inner">
                                            <div class="item-title item-label" v-if="$root.user.tipo == 'contratante'">Data de nascimento <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['##/##/####']" :masked="true" type="tel" placeholder="Sua data de nascimento" value="" class="form-control" autocomplete="new-password" v-model="form.dataNascimento"  required />
                                            </div>
                                        </div>
                                    </li>    
                                    <li class="item-content item-input col-100 pb-10" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Palavras-chave <small>(opcional)</small></div>
                                            <div class="item-input-wrap ">
                                                <div class="row">
                                                    <div class="col-80">
                                                        <input type="text" v-model="palavrasChave" v-on:keydown.enter.stop.prevent="addPalavrasChave" placeholder="Escreva a palavra-chave" value="" class="form-control "/>
                                                    </div>                                                                                                
                                                    <div class="col-15">
                                                        <button type="button" v-on:click="addPalavrasChave" class="button button-fill col-20">
                                                            <i class="las la-plus" style="font-size: 24px; margin-right: 0px"></i>
                                                        </button>                                                                                                
                                                    </div>                                                                                                
                                                </div>                                                                                                

                                                  <div class="chip" v-for="(item, index) in form.palavrasChave" v-if="item">
                                                    <div class="chip-label">{{item}}</div><a v-on:click="delPalavrasChave(item)" class="chip-delete"></a>
                                                  </div>                                           
                                            </div>
                                        </div>
                                    </li>                                      
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Currículo <small>(opcional)</small></div>
                                            <div class="item-input-wrap">
                                                <textarea v-model="form.descricao" style="min-height: 250px; background: #f7f7f7; padding: 5px" placeholder="Escreva o seu currículo aqui.." class="form-control"></textarea>
                                            </div>
                                        </div>
                                    </li>                                                                                                                   
                                </ul>

                                <p style="padding-left: 12px" v-if="$root.user.tipo == 'prestador'">
                                    <i class="las la-map-marker"></i> 
                                    Endereço
                                </p>

                                <ul class="row" v-if="$root.user.tipo == 'prestador'">
                                    <li class="item-content item-input col-60" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">CEP <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['#####-###']" :masked="true" type="tel" class="form-control" v-model="form.cep" placeholder="_____-___" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Rua <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.endereco" placeholder="Escreva o seu endereço.." value="" class="form-control" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Número (obrigatório)</div>
                                            <div class="item-input-wrap">
                                                <input type="tel" v-model="form.numero" placeholder="__" value="" class="form-control" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Complemento <small>(opcional)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.complemento" placeholder="" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>     
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Bairro <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.bairro" placeholder="Escreva o seu bairro.." value="" class="form-control" />
                                            </div>
                                        </div>
                                    </li>            
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'" >
                                        <div class="item-inner">
                                            <div class="item-title item-label">Cidade <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.cidade" placeholder="Escreva a sua cidade.." value="" class="form-control" />
                                            </div>
                                        </div>
                                    </li>     
                                    <li class="item-content item-input col-100" v-if="$root.user.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Estado <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <select id="estado" class="form-control" readonly="" name="estado" required="" v-model="form.estado" >
                                                    <option value="" disabled selected hidden>Estado</option>
                                                    <option value="AC">Acre</option>
                                                    <option value="AL">Alagoas</option>
                                                    <option value="AP">Amapá</option>
                                                    <option value="AM">Amazonas</option>
                                                    <option value="BA">Bahia</option>
                                                    <option value="CE">Ceará</option>
                                                    <option value="DF">Distrito Federal</option>
                                                    <option value="ES">Espírito Santo</option>
                                                    <option value="GO">Goiás</option>
                                                    <option value="MA">Maranhão</option>
                                                    <option value="MT">Mato Grosso</option>
                                                    <option value="MS">Mato Grosso do Sul</option>
                                                    <option value="MG">Minas Gerais</option>
                                                    <option value="PA">Pará</option>
                                                    <option value="PB">Paraíba</option>
                                                    <option value="PR">Paraná</option>
                                                    <option value="PE">Pernambuco</option>
                                                    <option value="PI">Piauí</option>
                                                    <option value="RJ">Rio de Janeiro</option>
                                                    <option value="RN">Rio Grande do Norte</option>
                                                    <option value="RS">Rio Grande do Sul</option>
                                                    <option value="RO">Rondônia</option>
                                                    <option value="RR">Roraima</option>
                                                    <option value="SC">Santa Catarina</option>
                                                    <option value="SP">São Paulo</option>
                                                    <option value="SE">Sergipe</option>
                                                    <option value="TO">Tocantins</option>
                                                </select>                                                  
                                            </div>
                                        </div>
                                    </li>  
                                </ul>                                  
                            </div>
                            <div class="clearfix container">
                                <button type="submit" class=" button-large button button-fill">
                                    <i class="las la-save"></i> 
                                    Salvar dados
                                </button>
                                <br><br>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
            
            
        </div>
              
        <Toolbar></Toolbar>
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'

import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'Conta',
    components: {
        'Toolbar': Toolbar,
        'Top':  Top,
        'AvatarCropper': AvatarCropper
    },       
    data () {
        var self                    = this;
        return {
            "palavrasChave":        null,
            "profissoes": {
                "ativa":            {
                    "empresa":      0
                },
                "itens":            []
            },                            
            "saldo": {
                "AmountAvailableToday":0,
                "AmountPreviewTotal": 0
            },            
            "loading": {
                "submit":           false
            },
            "especialidades": {
                "nomes":            "",
                "valor":            [
                ],
                "itens":            [                 
                ]
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             self.$root.user.nome,
                "email":            self.$root.user.email,
                "doc":              self.$root.user.doc,
                "cnpj":             self.$root.user.cnpj,
                "imagem":           self.$root.user.imagem,
                "telefone":         self.$root.user.telefone,
                "empresa":          self.$root.user.empresa,
                "endereco":         self.$root.user.endereco,
                "cep":              self.$root.user.cep,
                "numero":           self.$root.user.numero,
                "bairro":           self.$root.user.bairro,
                "cidade":           self.$root.user.cidade,
                "estado":           self.$root.user.estado,
                "complemento":      self.$root.user.complemento,
                "dataNascimento":   self.$root.user.dataNascimento.split("-")[2] + "/" + self.$root.user.dataNascimento.split("-")[1] + "/" + self.$root.user.dataNascimento.split("-")[0],
                "razaoSocial":      self.$root.user.razaoSocial,

                "categorias":       self.$root.user.categorias,
                "categoriasNomes":  self.$root.user.categoriasNomes,
                "registroClasse":   self.$root.user.registroClasse,
                "categoriaCod":     self.$root.user.categoriaCod,
                "palavrasChave":    self.$root.user.palavrasChave,
                "rqe":              self.$root.user.rqe,
                "descricao":        self.$root.user.descricao                
            }              
        }
    },
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },          
    },    
    watch: {
        "form.cep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        },
        "form.categoriaCod": function(val) {
            var self = this;
            console.log("change categoriaCod", val);
            var profissao = self.profissoes.itens.filter(function(item) {
                if (item.cod == val) return item;
            })[0];

            if (!profissao) profissao = {
                "empresa":      0                
            };

            console.log("Profissao:", profissao);
            self.profissoes.ativa = profissao;
            self.$forceUpdate();
        },           
    },    
    methods: {
        menu: function() {
            var self = this;
            console.log("menu");
            window.___app.dialog.create({
                title: 'Osis',
                text: '',
                buttons: [
                    {
                        text: 'Minha conta',
                        onClick: function() {
                            self.$root.go("Conta");
                        }
                    },
                    {
                        text: 'Alterar senha',
                        onClick: function() {
                            self.$root.go("AlterarSenha");
                        }
                    },             
                    {
                        text: 'Fale conosco',
                        onClick: function() {
                            self.$root.go("Contato");
                        }
                    },
                    {
                        text: 'Termos de uso',
                        onClick: function() {
                            loading.show();
                            setTimeout(function() {
                                self.$root.openModal('modal-termos-de-uso');
                            }, 500);
                        }
                    },      
                    {
                        text: 'Políticas de privacidade',
                        onClick: function() {
                            loading.show();
                            setTimeout(function() {
                                self.$root.openModal('modal-politicas-de-privacidade');
                            }, 500);
                            
                        }
                    },   
                    {
                        text: 'Deslogar',
                        onClick: function() {
                            self.$root.logout();
                        }
                    },                                                            
                    {
                        text: '<span style="color: red; font-weight: 200">Voltar<span>',
                    },                                                            
                ],
                verticalButtons: true,
            }).open();            
        },
        addPalavrasChave: function() {
            var self = this;
            console.log("addPalavrasChave()");

            self.form.palavrasChave.push(self.palavrasChave);
            self.palavrasChave = "";
            self.$forceUpdate();
        },
        delPalavrasChave: function(index) {
            var self = this;
            console.log("delPalavrasChave()", index);

            self.form.palavrasChave.splice(index, 1);
            self.$forceUpdate();
        },        
        autocompleteEspecialidades: function() {
            var self = this;
            console.log("autocompleteEspecialidades()");

            self.autocomplete = window.___app.autocomplete.create({
                // inputEl: '.autocomplete-dropdown-especialidades',
                openIn: 'popup',
                // preloader: true, 
                multiple: true,
                requestSourceOnOpen: true,
                // updateInputValueOnSelect: true,
                closeOnSelect: false,
                valueProperty: 'cod',
                textProperty: 'nome',
                popupCloseLinkText: "Fechar",
                notFoundText: "Nenhum resultado encontrado.",
                searchbarDisableText: "Cancelar",
                searchbarPlaceholder: "Pesquise..",
                value: self.especialidades.valor,
                // limit: 20,
                // typeahead: true,
                // dropdownPlaceholderText: 'Selecione as especialidades..',
                source: function (query, render) {
                    var autocomplete = this;
                    var results = [];
                    autocomplete.preloaderShow();

                    var clean = function(val) {
                        return (val ? val : "").toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim();
                    }

                    var itens = [];                        
                    var search= clean(query);

                    if (!self.form.categoriaCod) {
                        console.log("Erro autocomplete", self.autocomplete);
                        setTimeout(function() {
                            self.autocomplete.close();
                        }, 1000);
                        alert("Selecione a sua profissão.");
                        return false;
                    }

                    self.especialidades.itens.forEach(function(item) {
                        console.log("VALIDA >>> ", item, "categoriaCod:", self.form.categoriaCod, "==", item.categoriaCod);
                        if ((clean(item.nome).indexOf(search) != -1) && item.categoriaCod == self.form.categoriaCod) {
                            itens.push(item);
                        }
                    });

                    autocomplete.preloaderHide();
                    render(itens);

                },
                on: {
                    change: function (value) {
                        console.log("change", value);

                        var nomes   = "";

                        value.forEach(function(item) {
                            nomes += item.nome + ", ";
                        });

                        nomes       = nomes.substr(0, nomes.length - 2);

                        self.especialidades.nomes = nomes;
                   
                        self.$forceUpdate();
                    },
                }                
            });

            console.log("autocomplete:", self.autocomplete)

            self.autocomplete.open();

        },
        escolherImagem: function(campo, camera) {
            console.log("escolherImagem()", campo)
            var self = this;
            loading.show();
            navigator.camera.getPicture(function(imageData) {
                self.form[campo] = "data:image/jpeg;base64," + imageData;
                console.log("setou form", campo)
                self.$forceUpdate();
                loading.hide();
                
            }, function(message){
                console.log("erro", message)
                loading.hide();

            }, {
                quality: 35,
                // saveToPhotoAlbum: true,
                destinationType: Camera.DestinationType.DATA_URL,
                targetWidth: 1000,
                correctOrientation: true,
                targetHeight: 0
            });                        

        },          
        getCategorias: function() {
            var self        = this;
            console.log("getCategorias()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "all":          true
                    }
                };

                axios.get("api/categorias.php", form)
                .then(response => {
                    
                    console.log("getCategorias() response", response);
                    self.categorias                     = response.data.result;

                    console.log("Buscou categorias", self.categorias);

                    var profissoes      = [];
                    var especialidades  = [];
                    var especialidadesCods = self.form.categorias.split(",");
                    self.especialidades.valor = [];

                    self.categorias.itens.forEach(function(item) {
                        if (item.tipo == "profissao") {
                            profissoes.push(item);
                        }
                        if (item.tipo == "especialidade") {

                            if (especialidadesCods.indexOf(item.cod) != -1) {
                                console.log("Possui cod", item);
                                self.especialidades.valor.push(item);
                            }

                            especialidades.push(item);
                        }                        
                    });

                    self.especialidades.nomes   = self.form.categoriasNomes;
                    self.especialidades.itens   = especialidades;
                    self.profissoes.itens       = profissoes;

                    if (self.form.categoriaCod) {
                        var profissao = self.profissoes.itens.filter(function(item) {
                            if (item.cod == self.form.categoriaCod) return item;
                        })[0];

                        if (!profissao) profissao = {
                            "empresa":      0                
                        };

                        console.log("Profissao:", profissao);
                        self.profissoes.ativa = profissao;
                    }

                
                    self.$forceUpdate();
                    self.$root.$forceUpdate();

                    console.log("Especialidades:", especialidadesCods);

                    console.log("Setou especialidades e profissoes", self.especialidades, self.profissoes)

                    // loading.hide();
                    setTimeout(function() {
                        resolve(response.data.result);
                    }, 500);
  
                })
                .catch(error => {
                    console.log("getCategorias() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                           
                });   

            });   
        },      
        sacar: function() {
            var self    = this;

            var form            = {};
            form._cod           = self.$root.user.cod;
            form._token         = self.$root.user.token;
            form.acao           = "sacar";
            loading.show();
            
            axios.put("api/carteira.php", form)
            .then(response => {
                console.log("renovar() responde", response.data);
                alert(response.data.message);
                self.getSaldo().finally(function() {
                    loading.hide();
                });
            })
            .catch(error => {
                console.log("renovar() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                                
            });  
        },   
        getSaldo: function() {
            // console.log("getSaldo()");
            var self = this;
            return new Promise(function(resolve, reject) {

                var form            = {};
                form._cod           = self.$root.user.cod;
                form._token         = self.$root.user.token;
                form.tipo           = "saldo";

                axios.get("api/carteira.php", {"params": form})
                .then(response => {
                    
                    console.log("getSaldo() response", response);
                    self.saldo      = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getSaldo() error", error);

                    resolve(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    
                }); 
            }); 

        },                   
        atualizarCEP: function(val) {
            var self    = this;
            if (val) {
                if (val.length == 9) {
                    axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                    .then(response => {
                        if (response.data) {
                            if (response.data.logradouro) {
                                self.form.endereco  = response.data.logradouro;
                                self.form.bairro    = response.data.bairro;
                                self.form.cidade    = response.data.localidade;
                                self.form.estado    = response.data.uf;
                                self.$forceUpdate();
                            }
                        }
                    })
                    .catch(error => {
                    });
                }
            }
        }, 
        submitAvatar: function(e) {
            var self = this;
            console.log("submitAvatar()", e)
            loading.show();
        },    
        uploadAvatar: function(e) {
            var self = this;
            console.log("uploadAvatar()", e)
            loading.show();
            // self.form.imagem = e.getCroppedCanvas().toDataURL();
            e.getCroppedCanvas().toBlob((blob1) => {
                reduceFileSize(blob1, 500*1024, 800, Infinity, 0.6, blob2 => {
                    blobToBase64(blob2, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form.imagem    = result;
                        self.$forceUpdate();
                    });
                });             
            });
            return true;
        },       
        submit: function(e) {
            
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form));

            if (self.$root.user.tipo == "prestador") {
                form.categoriasNomes       = self.especialidades.nomes;
                form.categorias            = [];
                self.especialidades.valor.forEach(function(item) {
                    form.categorias.push(item.cod);
                });
                form.categorias            = form.categorias.join(",");
                form.palavrasChave         = form.palavrasChave.join(",");
            }             

            console.log("submit", form);
            e.preventDefault();
            loading.show();

            var request = function() {
                
                axios.put("api/conta.php", form)
                .then(response => {
                    console.log("ok", response.data.result)

                    $(".page-content")[0].scrollTo({
                        top: 5
                    });                                             
                    loading.hide();
                    self.$root.getUser();
                    alert(response.data.message);
                    // self.$root.setUser(response.data.result);

                })
                .catch(error => {
                    loading.hide(); 
                    alert(error.response.data.message || "Erro! Por favor, tente novamente.");
                });
            }

            if (self.$root.user.tipo == "prestador") {
                var geocoder                = new google.maps.Geocoder();
                var endereco                = self.form.endereco + ", " + self.form.numero + " - " + self.form.bairro + ", " + self.form.cidade + " - " + self.form.estado + ", " + self.form.cep;
                geocoder.geocode({ 'address': endereco}, function (results, status) {

                    console.log("Localizacao resultado >>", results)

                    if (results[0]) {

                        var latitude        = results[0].geometry.location.lat();
                        var longitude       = results[0].geometry.location.lng();
                        form.latitude       = latitude;
                        form.longitude      = longitude;
                        console.log("Setou localizacao", self.form);
                        self.$forceUpdate();
                        request();
                    } else {
                        loading.hide();
                        alert("Erro! Informe um endereço válido e tente novamente por favor.")
                    }

                });                  
            } else {
                request();
            }

        }
    },    
    mounted: function() {
        var self = this;
        console.log("mounted >>>")
        loading.show();
        self.$root.getUser().finally(function(result) {

            loading.show();

            console.log("Buscou usuario>>", result)

            self.form = {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             self.$root.user.nome,
                "email":            self.$root.user.email,
                "doc":              self.$root.user.doc,
                "cnpj":             self.$root.user.cnpj,
                "imagem":           self.$root.user.imagem,
                "telefone":         self.$root.user.telefone,
                "empresa":          self.$root.user.empresa,
                "endereco":         self.$root.user.endereco,
                "cep":              self.$root.user.cep,
                "numero":           self.$root.user.numero,
                "bairro":           self.$root.user.bairro,
                "cidade":           self.$root.user.cidade,
                "estado":           self.$root.user.estado,
                "complemento":      self.$root.user.complemento,
                "dataNascimento":   self.$root.user.dataNascimento.split("-")[2] + "/" + self.$root.user.dataNascimento.split("-")[1] + "/" + self.$root.user.dataNascimento.split("-")[0],
                "razaoSocial":      self.$root.user.razaoSocial,
                "latitude":         self.$root.user.latitude,
                "longitude":        self.$root.user.longitude,
                "categorias":       self.$root.user.categorias,
                "categoriasNomes":  self.$root.user.categoriasNomes,
                "registroClasse":   self.$root.user.registroClasse,
                "rqe":              self.$root.user.rqe,            
                "categoriaCod":     self.$root.user.categoriaCod,            
                "palavrasChave":    self.$root.user.palavrasChave.split(","),
                "descricao":        self.$root.user.descricao
            };

            self.$forceUpdate();

            var swiper = new Swiper('.user-swiper', $(".user-swiper").data());


            if (self.$root.user.tipo == "prestador") {
                loading.show();
                self.getSaldo().finally(function() {
                    loading.show();
                    if (self.$root.user.tipo == "prestador") {
                        self.getCategorias().finally(function() {
                            setTimeout(function() {
                                self.$forceUpdate();
                                loading.hide();
                                self.$root.getPasso();

                            }, 500);
                        });
                    } else {
                        loading.hide();
                    }
                });
            } else {
                loading.hide();
            }
        });
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
    .imagem-preview {
        width: 100%;
        display: block;
        height: 25vh;
        border-radius: 30px;
        margin-bottom: 10px;
        background-size: auto 100%;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
        margin-top: 5px;
    }    

    .checkb {
        position: absolute;
        left: 15px;
        font-size: 20px
    }   

    .uploadButton-input {
        /*position: absolute;*/
        /*top: -888888px;*/
        visibility: hidden;
        position: absolute;
        left: -99999999px;
    }

    .imagem-preview {
        width: 100%;
        display: block;
        height: 25vh;
        border-radius: 30px;
        margin-bottom: 10px;
        background-size: auto 100%;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
        margin-top: 5px;
    }    

    .checkb {
        position: absolute;
        left: 15px;
        font-size: 20px
    }   

    .profile-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .profile-info button {
        width: auto;
        margin-top: 10px;
        opacity: 1;
    }

    .profile-content p span {
        opacity: 0.75;
        letter-spacing: 0.5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Conta.vue